import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Select, Button, Card, message, Table, Progress, Input } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { Navigate } from "react-router-dom";
import Cookies from 'js-cookie';
import { useNavigate, useLocation } from 'react-router-dom';
import mammoth from 'mammoth';
import ModernResultsStep from './ModernResultsStep';


import axios from 'axios';
import JobDescriptionStep from './JobDescriptionStepModern';
import CVUpload from './CVUpload';
import NavigationBar from './NavigationBar';
import AnalysisStep from './AnalysisStep';
import ModernAnalysisStep from './ModernAnalysisStep';
import ModernHistoricalStep from './ModernHistoricalStep';

import BlueBanner from './BlueBanner';
import UpperBanner from './UpperBanner';
import SettingsPage from './SettingsPage';
import PreScreeningModal from './PreScreeningModal';
import ResultsModal from './ResultsModal';
import SummaryModal from './SummaryModal';
import PreviewCVModal from "./PreviewCVModal";
import RankingTable from './RankingTable';
import PrescreeningStatusModal from './PrescreenStatusModal';
import { STATUS_MAP } from '../utils/constants';

import '../custom-table-header.css';
import '../progress_blur.css';
import '../transitions.css';
import '../CSS/Buttons.css';
import {string} from "react-table/src/sortTypes";

const backend_url = process.env.REACT_APP_BACKEND_URL;
const initialState = {};



const AdditionalCriteriaInput = ({ label, value, onChange }) => (
    <div>
        <label>{label}</label>
        <Input value={value} onChange={onChange} />
    </div>
);

const RankingPage = ({ loggedIn, onLogout }) => {
    const [flags, setFlags] = useState(initialState);
    const location = useLocation();
    const step = Number(new URLSearchParams(location.search).get('step'));
    const [currentStep, setCurrentStep] = useState(step || 1);
    const [jdFiles, setJdFiles] = useState([]);
    const [cvFiles, setCvFiles] = useState([]);
    const [data, setData] = useState([]);
    const [isMainUploadLoading, setIsMainUploadLoading] = useState(false);
    const [returnedCriteria, setReturnedCriteria] = useState([])
    const [historicalData, setHistoricalData] = useState([]);
    const [manualEntryUsed, setManualEntryUsed] = useState(false);
    const [manualEntryVisible, setManualEntryVisible] = useState(false);
    const [uploadUsed, setuploadUsed] = useState(false);
    const [manualJDData, setManualJDData] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState({
        firstPriority: 'Default',
        secondPriority: 'Default',
        thirdPriority: 'Default',
        manualUsed: "false",
        chosenJD: "",
        AdditionalContentImportance: "medium",
    });
    const [additionalCriteria, setAdditionalCriteria] = useState({
        criteria1: "",
        criteria2: "",
        criteria3: "",
    });
    const [selectedHistoricalJD, setSelectedHistoricalJD] = useState("");
    const [jobName, setJobName] = useState(""); // Used to populate the prescreening Request job Title field
    const [jobID, setJobID] = useState("") // Used to inform the prescreening request API
    const uploadingJobIDRef = useRef(""); // Reference to jobID used by the event source to avoid closure.

    const [existingJDList, setExistingJDList] = useState([]);
    const [jdListLoading, setJdListLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [showCheck, setShowCheck] = useState(false);
    const [isUploadDisabled, setIsUploadDisabled] = useState(false);
    const [showResultsTable, setShowResultsTable] = useState(false);
    const [isBackButtonClicked, setIsBackButtonClicked] = useState(false);

    const [showPrescreenModal, setShowPrescreenModal] = useState(false);
    const [prescreenRecord, setPrescreenRecord] = useState(null);
    const [showPrescreenResultModal, setShowPrescreenResultModal] = useState(false);
    const [AdditionalContent, setAdditionalContent] = useState("");
    const [summaryRecord, setSummaryRecord] = useState(false);
    const [showSummaryModal, setShowSummaryModal] = useState(null);
    const [cvRecord, setCVRecord] = useState(null); // do we actually use this?
    const [showCVModal, setShowCVModal] = useState(false);
    const [isMultiSelect, setIsMultiSelect] = useState(true);
    const [selectedCandidates, setSelectedCandidates] = useState([]);
    const [prescreenLoading, setPrescreenLoading] = useState({});
    const [showPrescreenStatusModal, setShowPrescreenStatusModal] = useState(false);
    const [prescreenStatuses, setPrescreenStatuses] = useState({}); 
    const [jdFilepath, setJdFilepath] = useState('');
    const [jdText, setJdText] = useState('');
    const [jobData, setJobData] = useState(null);


    const ENABLE_MULTISELECT_FEATURE = true;

    useEffect(() => {
        console.log('selectedCandidates in RankingPage:', selectedCandidates);
    }, [selectedCandidates]);

    // Flag Colours
    const cycleColor = (record) => {
        const applicationID = record.ApplicationID;
        const nextColor = {
            '': '#a8071a',
            '#a8071a': '#237804',
            '#237804': '#d4b106',
            '#d4b106': '',
        };

        const newColor = nextColor[flags[applicationID] || ''];
        setFlags(prevFlags => ({ ...prevFlags, [applicationID]: newColor }));
        sendColorUpdate(record.ApplicationID, newColor);
    };

    const sendColorUpdate = (applicationID, color) => {
        const queryURL = "?sessionID=" + getCookie("userSession") + "&applicationID=" + applicationID + "&color=" + encodeURIComponent(color);
        axios.post(backend_url + '/v1/update-flag' + queryURL)
            .then(response => console.log('Color updated successfully'))
            .catch(error => console.error('Error updating color:', error));
    };

    // File Event Handling
    const handleJdFilesAdded = (files) => {
        console.log('=== handleJdFilesAdded Debug ===');
        console.log('files:', files);
        console.log('files[0]:', files[0]);
        console.log('files[0].path:', files[0]?.path);
        console.log('files[0].name:', files[0]?.name);
        console.log('files[0].type:', files[0]?.type);
        
        setJdFiles(files);
        setuploadUsed(true);

        // Clear manual entry state when upload is used
        if (files.length > 0) {
            setManualEntryUsed(false);
            setManualJDData([]);
            setSelectedOptions(prev => ({
                ...prev,
                manualUsed: "false"
            }));
        }
        if (files.length > 0) {
            const filePath = files[0].path || files[0].name;
            console.log('Setting jdFilepath to:', filePath);
            setJdFilepath(files[0].path || files[0].name);
            setJdText('');
        }
    };

    useEffect(() => {
        console.log("cvFiles after change: ", cvFiles);
    }, [cvFiles]);

    useEffect(() => {
        window.clearManualEntry = handleClearManualEntry;
        window.clearUpload = handleClearUpload;

        return () => {
            delete window.clearManualEntry;
            delete window.clearUpload;
        };
    }, []);

    const handleCvFilesAdded = (newFiles) => {
        setCvFiles(currentFiles => [...currentFiles, ...newFiles]);
    };

    const handleListEmpty = () => {
        setuploadUsed(false);
    };

    const handleDeleteCvFile = (file) => {
        console.log("=== DELETE DEBUG ===");
        console.log("File to delete:", file);
        console.log("cvFiles before deletion:", cvFiles);
        setCvFiles(currentFiles => {
            // Getting the information of all the files
            currentFiles.forEach((item, index) => {
                console.log(`File ${index}:`, {
                    uid: item.uid,
                    path: item.path,
                    name: item.name,
                    fullItem: item
                });
            });
            console.log("File to delete uid:", file.uid); // uid = NONE
            console.log("File to delete path:", file.path);
            console.log("File to delete name:", file.name);
            const updatedFiles = currentFiles.filter(item => item.name !== file.name); // use name to delete instead
            console.log("cvFiles after deletion:", updatedFiles);
            return updatedFiles;
        });
    };

    const resetApplicationState = async () => {
        console.log("Resetting Application State")
        setCurrentStep(1);
        setJdFiles([]);
        setCvFiles([]);
        setIsMainUploadLoading(false)
        setData([]);
        setSelectedOptions({
            firstPriority: 'Default',
            secondPriority: 'Default',
            thirdPriority: 'Default',
            manualUsed: "false",
            chosenJD: "",
            AdditionalContentImportance: "medium",
        });
        setAdditionalContent('')
        setManualEntryUsed(false);
        setManualJDData([]);
        setShowResultsTable(false);
        setReturnedCriteria([]);
        setFlags(initialState);
        setHistoricalData([]);
        setManualEntryVisible(false);
        setuploadUsed(false);
        setAdditionalCriteria({
            criteria1: "",
            criteria2: "",
            criteria3: "",
        });
        setSelectedHistoricalJD("");
        uploadingJobIDRef.current = "";
        setProgress(0);
        setShowCheck(false);
        setIsUploadDisabled(false);
        setShowResultsTable(false);
        console.log("Resetting the application data")
        setSelectedCandidates([]);


        const jdList = await SelectExistingJD("true");
        setExistingJDList(jdList);
    };

    const getCookie = (name) => {
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
        //console.log("Cookie full search:", document.cookie)
        //console.log("Cookie match:", match)
        return match ? match[1] : null;
    };

    // Should not be used anymore-Marked for deletion
    const createCookie = async () => {
        try {
            const response = await axios.get(backend_url + '/v1/generate-cookie');
            Cookies.set('userSession', response.data, { expires: 1 });
            return response.data;
        } catch (error) {
            console.error(error);
        }
    };

    const navigate = useNavigate();
    const navigateToSettings = () => navigate('/settings');

    useEffect(() => {

        // Check if cookie exists as page first loads:
        if(!getCookie("userSession")) {
            console.log("Warning no cookie found:")
            onLogout();
            return
        }

        const fetchJDList = async () => {
            setJdListLoading(true);
            const jdList = await SelectExistingJD("true");
            setExistingJDList(jdList);
            setJdListLoading(false);
        };

        fetchJDList();
    }, []);

    useEffect(() => {
        //document.body.style.background = 'linear-gradient(135deg, #141414 0%, #1f1520 50%, #141414 100%)';
        //document.body.style.background = '#F3E8F8';
        document.body.style.background = '#121212';
        document.body.style.minHeight = '100vh';
        return () => {
            document.body.style.background = null;
            document.body.style.minHeight = null;
        };
    }, []);

    const handleMultiplePrescreen = () => {
        console.log("Handling multiple prescreen request for:", selectedCandidates);
        setPrescreenRecord(selectedCandidates); // Pass array of candidates
        setShowPrescreenModal(true);
    };

    const handleRetryPrescreen = (record) => {
        setPrescreenRecord(record);
        setShowPrescreenModal(true);
    };
    /*
    const handleMultiplePrescreen = () => {
    Promise.all(selectedCandidates.map(candidate =>
      axios.get(`${backend_url}/v1/prescreen-result?sessionID=${getCookie("userSession")}&applicationID=${candidate.ApplicationID}`)
    )).then(responses => {
      const validCandidates = selectedCandidates.filter((candidate, index) =>
        responses[index].data.status === "none"
      );

      if (validCandidates.length > 0) {
        setPrescreenRecord(validCandidates);
        setShowPrescreenModal(true);
      } else {
        message.info('All selected candidates already have pending or completed prescreenings');
      }
    });
  };
     */

// getting the status of prescreen
// From prescreen log
    const handleUnifiedPrescreenClick = async (record) => {
        const applicationId = record.ApplicationID;

        // Show loading state immediately for this specific candidate
        setPrescreenLoading(prev => ({ ...prev, [applicationId]: true }));

        try {
            const timeoutPromise = new Promise((_, reject) =>
                setTimeout(() => reject(new Error('Request timeout')), 5000)
            );

            const fetchPromise = axios.get(
                `${backend_url}/v1/prescreen-result?sessionID=${getCookie("userSession")}&applicationID=${applicationId}`
            );

            const response = await Promise.race([fetchPromise, timeoutPromise]);

            // Case 1: No prescreening exists yet - show setup modal
            if (response.data.status === "none") {
                setPrescreenRecord(record);
                setShowPrescreenModal(true);
                return;
            }

            // Case 2: Prescreening is in progress - show status modal
            if (response.data.status === "pending") {
                setPrescreenRecord(record);
                setShowPrescreenStatusModal(true); // Show our new status modal
                return;
            }

            // Case 3: Prescreening is complete - show results modal
            if (response.data && Object.keys(response.data).length > 0) {
                setPrescreenRecord(record);
                setShowPrescreenResultModal(true);
                return;
            }

            message.error("Unexpected response from server");

        } catch (error) {
            if (error.message === 'Request timeout') {
                message.error("Request timed out - please try again");
            } else {
                console.error('Error checking prescreening status:', error);
                message.error("Error checking prescreening status");
            }
        } finally {
            setPrescreenLoading(prev => ({ ...prev, [applicationId]: false }));
        }
    };

    // Get prescreen button color based on status
    const getPrescreenButtonColor = (applicationId) => {
        const statusInfo = prescreenStatuses[applicationId];
        if (!statusInfo) {
            return '#d9d9d9'; // Default light gray for unknown status
        }

        const status = statusInfo.status;
        const originalStatus = statusInfo.originalStatus;
        const data = statusInfo.data;
        
        // 1. Success states priority: green (highest priority)
        if (status === 'completed' || originalStatus === 'ready') {
            return STATUS_MAP.completed?.color || '#d4edda';
        }
        
        // 2. Failure states: determine color based on retry count (check this BEFORE pending)
        const failureStatuses = ['busy', 'silent', 'voicemail', 'hungup', 'unreachable', 'missed', 'international_blocked', 'twilio_error', 'call_failed'];
        if (failureStatuses.includes(status)) {
            const currentRetries = parseInt(data?.CurrentRetryCounts);
            const maxRetries = parseInt(data?.MaxRetryCounts);
            // All retries failed + reached max retries: red
            if (currentRetries >= maxRetries + 1) {
                return STATUS_MAP[status]?.color || '#f8d7da';
            } else {
                // Some retries failed + not reached max retries: yellow
                console.log(`Returning YELLOW color for status: ${status}`);
                return STATUS_MAP.retry_pending?.color || '#fff3cd';
            }
        }
        
        // 3. First call initiated: immediately turn yellow (pending status)
        if (originalStatus === 'pending') {
            return STATUS_MAP.pending?.color || '#fff3cd';
        }
        
        // 6. Not started: gray
        if (originalStatus === 'none') {
            return STATUS_MAP.none?.color || '#d9d9d9';
        }
        
    };

    // Check prescreen status for auto-refresh - Unified data fetching
    const checkPrescreenStatus = async (applicationId) => {
        try {
            // Get original status first (none/pending/ready)
            const response = await axios.get(
                `${backend_url}/v1/prescreen-result?sessionID=${getCookie("userSession")}&applicationID=${applicationId}`
            );
            
            // Get detailed status from prescreen log (completed/busy/silent/etc.)
            let detailedStatus = response.data.status; // Default to original status
            let hasLogEntries = false;
            try {
                const logResponse = await axios.get(
                    `${backend_url}/v1/prescreen-log?sessionID=${getCookie("userSession")}&applicationID=${applicationId}`
                );
                if (logResponse.data.logs && logResponse.data.logs.length > 0) {
                    hasLogEntries = true;
                    const latestLog = logResponse.data.logs[0];
                    if (latestLog.Status) {
                        detailedStatus = latestLog.Status; // Use latest log status
                    }
                }
            } catch (logError) {
                console.warn('Could not fetch prescreen log:', logError);
            }
            
            // If API returns "none" but PrescreenLog has entries, task was completed
            if (response.data.status === "none" && hasLogEntries) {
                console.log(`Task for ${applicationId} was completed but API returned "none", keeping previous status`);
                return; // Don't update status, keep previous state
            }
            
            // Get retry information from prescreen-status API
            let retryData = null;
            try {
                const statusResponse = await axios.get(
                    `${backend_url}/v1/prescreen-status?sessionID=${getCookie("userSession")}&applicationID=${applicationId}`
                );
                retryData = statusResponse.data;
            } catch (statusError) {
                console.warn('Could not fetch prescreen status:', statusError);
            }
            
            // Update status with comprehensive data
            setPrescreenStatuses(prev => ({
                ...prev,
                [applicationId]: {
                    status: detailedStatus,           // Detailed status from log (completed/busy/silent/etc.)
                    originalStatus: response.data.status, // Overall status of the call(none/pending/ready)
                    timestamp: Date.now(),
                    data: retryData,                  // Retry count data
                    forceUpdate: Date.now() 
                }
            }));
            
            // Force immediate re-render
            setRenderKey(prev => prev + 1);
        } catch (error) {
            console.error('Error refreshing prescreen status:', error);
        }
    };

    // Auto-refresh
    useEffect(() => {
        const interval = setInterval(() => {
            // Refresh all candidates with prescreen status
            Object.keys(prescreenStatuses).forEach(applicationId => {
                const statusInfo = prescreenStatuses[applicationId];
                if (statusInfo) {
                    checkPrescreenStatus(applicationId);
                }
            });
        }, 300000); // Check every 5 minutes

        return () => clearInterval(interval);
    }, [prescreenStatuses]);

    // Force re-render
    const [renderKey, setRenderKey] = useState(0);
    useEffect(() => {
        setRenderKey(prev => prev + 1);
    }, [prescreenStatuses]);

    const handleUpload = () => {
        setIsMainUploadLoading(true);
        if (isObjectEmpty(selectedOptions)) {
            message.error('Please select your priorities.');
            setIsMainUploadLoading(false);
            return;
        }

        if (cvFiles.length === 0) {
            message.error('Please add at least one CV file before uploading.');
            setIsMainUploadLoading(false);
            return;
        }
        setProgress(0);

        const formData = new FormData();
        const uploadDate = new Date().toISOString();

        jdFiles.forEach(file => {
            formData.append('jdFiles', file);
            formData.append('uploadDates', uploadDate);
        });

        const validCvFiles = cvFiles.filter(file => file && file.path && file.size > 0);
        console.log("Valid CV files for upload:", validCvFiles);
        
        validCvFiles.forEach(file => {
            console.log("Adding CV file to form data:", file);
            formData.append('cvFiles', file);
        });

        const criteriaString = JSON.stringify(additionalCriteria);
        formData.append('criteria', criteriaString);

        selectedOptions.AdditionalContent = AdditionalContent
        const selectedOptionsString = JSON.stringify(selectedOptions);
        console.log(selectedOptionsString)
        formData.append('manualJD', selectedOptionsString);

        const manualJDDataString = JSON.stringify(manualJDData[0]);
        formData.append('manualJDData', manualJDDataString);


        const appendCookieToFormData = async (formData) => {
            var userCookie = "default";
            console.log("Cookie to be added:", getCookie("userSession"))
            if (!getCookie("userSession")) {
                // This needs to log them out
                //userCookie = await createCookie();
                console.log("Warning no cookie found:")
                onLogout();
            } else {
                userCookie = getCookie("userSession");
            }
            formData.append('Cookie-Value', userCookie);
            console.log("Adding cookie to form data:", userCookie)
            return formData;
        };

        if (cvFiles.length > 0 && !isObjectEmpty(selectedOptions)) {
            console.log("This is good")

        }

        // Main progress handling
        // Firstly tries to do SSE to receive progress updates
        // IF SSE fails (some customer's antivirus or browser do this, then revert to regularly scheduled HTTP calls)
        let evtSource;
        let progressTimeout;
        let intervalId; // controls regular HTTP calling

        const connectEventSource = (regular, jobID_upload) => {
            console.log("Initiating progress handling, jobid", jobID_upload);

            // Define actions to do once 100% progress reached
            const finishedProgress = () => {
                getProcessedResults(uploadingJobIDRef.current);
                setLoading(false);
                setShowCheck(true); // Show the green tick Mark for 2s
                setTimeout(() => {
                    setShowCheck(false);
                }, 2000);
                console.log("Selected Historical JD from main upload at end of event source:", uploadingJobIDRef.current);
                setShowResultsTable(true);
            };

            // Define regular (not SSE) version of getting progress
            let progressComplete = false;

            const pollProgressRegularly = () => {
                intervalId = setInterval(() => {
                    if (progressComplete) {
                        clearInterval(intervalId);
                        console.log("backup polling stop, Poll progress:", progressComplete);
                        return;
                    }

                    axios.get(backend_url + '/v1/progress', {
                        params: {
                            sessionID: getCookie("userSession"),
                            single: true,
                            jobID: jobID_upload
                        }
                    })
                        .then(response => {
                            const progressData = response.data;
                            console.log("Polled progress:", progressData);

                            // Handle new progress response format
                            if (typeof progressData === 'object' && progressData.progress !== undefined) {
                                // New enhanced format
                                setProgress(progressData.progress);

                                // Handle error states
                                if (progressData.status === 'failed') {
                                    console.log("Job failed:", progressData.errorMessage || 'Unknown error');
                                    message.error(`Job failed: ${progressData.errorMessage || 'Unknown error'}`);
                                    progressComplete = true;
                                    clearInterval(intervalId);
                                    setLoading(false);
                                    setIsMainUploadLoading(false);
                                    return;
                                }

                                // Handle completion
                                if (progressData.progress >= 100 || progressData.status === 'completed') {
                                    console.log("Processing complete from polling");
                                    progressComplete = true;
                                    clearInterval(intervalId);
                                    finishedProgress();
                                }
                            } else {
                                // Fallback for old format (just progress number)
                                const progress = parseInt(progressData.progress || progressData, 10);
                                setProgress(progress);
                                if (progress >= 100) {
                                    progressComplete = true;
                                    clearInterval(intervalId);
                                    finishedProgress();
                                }
                            }
                        })
                        .catch(error => {
                            progressComplete = true;
                            clearInterval(intervalId);
                            message.error('Failed to get progress updates');
                            setLoading(false);
                            setIsMainUploadLoading(false);
                            console.error("Progress polling error:", error);
                        });
                }, 3000);
            };

            if (!regular) {
                // Main SSE method
                console.log("The jobid for progressupdates is", jobID_upload);
                console.log("Progress SSE URL with sessionCookie:", backend_url + '/v1/progress?sessionID=' + getCookie("userSession") + "&single=false&jobID=" + jobID_upload);
                const params = new URLSearchParams({
                    sessionID: getCookie("userSession"),
                    single: "false",
                    jobID: jobID_upload
                });

                // Build the URL with the URLSearchParams
                const progressUrl = `${backend_url}/v1/progress?${params.toString()}`;

                console.log("Progress SSE URL with sessionCookie:", progressUrl);
                evtSource = new EventSource(progressUrl);

                evtSource.onmessage = function(event) {
                    try {
                        // Try to parse as new enhanced progress format
                        const progressData = JSON.parse(event.data);
                        console.log("Enhanced progress update:", progressData);

                        setProgress(progressData.progress || 0);

                        // Handle error states
                        if (progressData.status === 'failed') {
                            console.log("Job failed:", progressData.errorMessage || 'Unknown error');
                            message.error(`Job failed: ${progressData.errorMessage || 'Unknown error'}`);
                            evtSource.close();
                            clearTimeout(progressTimeout);
                            setLoading(false);
                            setIsMainUploadLoading(false);
                            return;
                        }

                        // Handle completion
                        if (progressData.progress >= 100 || progressData.status === 'completed') {
                            console.log("Progress finished in enhanced SSE path");
                            clearTimeout(progressTimeout);
                            evtSource.close();
                            finishedProgress();
                        } else if (progressData.progress === 0) {
                            // If progress is still 0 after 5s, then give up on SSE and go to regular standard HTTP calls
                            const giveUpTime = 5000; //ms
                            progressTimeout = setTimeout(() => {
                                console.log("Progress stuck at 0%, switching to regular API call");
                                evtSource.close();
                                pollProgressRegularly();
                            }, giveUpTime);
                        } else {
                            clearTimeout(progressTimeout);
                            progressTimeout = null;
                        }
                    } catch (error) {
                        console.log("Falling back to old progress format");
                        const progress = parseInt(event.data, 10);
                        setProgress(progress);
                        console.log("Progress from SSE (fallback):", progress);
                        if (progress >= 100) {
                            console.log("Progress finished in SSE fallback path");
                            clearTimeout(progressTimeout);
                            evtSource.close();
                            finishedProgress();
                        } else if (progress === 0) {
                            const giveUpTime = 5000;
                            progressTimeout = setTimeout(() => {
                                console.log("Progress stuck at 0%, switching to regular API call");
                                evtSource.close();
                                pollProgressRegularly();
                            }, giveUpTime);
                        } else {
                            clearTimeout(progressTimeout);
                            progressTimeout = null;
                        }
                    }
                };

                // Handle failed connection
                evtSource.onerror = function(err) {
                    console.log("EventSource failed:", err);
                    evtSource.close();
                    // Switch to regular HTTP call version of progress updates
                    console.log("EventSource failed after retries, switching to regular API call");
                    pollProgressRegularly();
                };

                evtSource.onopen = function() {
                    console.log("EventSource connected successfully");
                };
            } else {
                // HTTP method
                pollProgressRegularly();
            }
        };



        // Main upload request. Has some relation to the progress too
        appendCookieToFormData(formData).then(updatedFormData => {
            axios.post(backend_url + '/v1/upload', updatedFormData, {
                headers: {'Content-Type': 'multipart/form-data'},
                validateStatus: status => (status >= 200 && status < 300) || status === 402 || status === 409
            })
                .then(response => {
                    if (response.status === 402) {
                        // Error handling for limits and account restrictions
                        if (evtSource && evtSource.readyState !== EventSource.CLOSED) {
                            evtSource.close();
                        }
                        if (intervalId) {
                            clearInterval(intervalId);
                        }
                        
                        const errorInfo = response.data;
                        
                        // Map error types to display titles
                        const errorTitles = {
                            'CV_LIMIT_EXCEEDED': 'CV Usage Limit Reached',
                            'TRIAL_EXPIRED': 'Trial Period Expired',
                            'SUBSCRIPTION_EXPIRED': 'Subscription Expired',
                            'ACCOUNT_EXPIRED': 'Account Membership Expired',
                            'CORPORATION_INACTIVE': 'Account Inactive',
                            'JOB_LIMIT_EXCEEDED': 'Job Limit Reached'
                        };
                        
                        // Get error type and title
                        const errorType = errorInfo.errorType || 'CV_LIMIT_EXCEEDED';
                        const errorTitle = errorTitles[errorType] || 'Usage Limit Reached';
                        const errorMessage = errorInfo.message || errorInfo;
                        
                        message.error({
                            content: (
                                <div>
                                    <p><strong>{errorTitle}</strong></p>
                                    <p>{errorMessage}</p>
                                </div>
                            ),
                            duration: 10,
                        });
                        setLoading(false);
                        setIsMainUploadLoading(false);
                        return;
                    }

                    if (response.status === 409) {
                        // Handle job already running error
                        console.log("Job conflict response:", response.data);

                        if (evtSource && evtSource.readyState !== EventSource.CLOSED) {
                            evtSource.close();
                        }
                        if (intervalId) {
                            clearInterval(intervalId);
                        }

                        // Display error with notification
                        const errorInfo = response.data;
                        const statusText = errorInfo.status || 'processing';

                        message.error({
                            content: (
                                <div>
                                    <p><strong>Job Already Running</strong></p>
                                    <p>{errorInfo.message || `This job is currently in ${statusText} status.`}</p>
                                    <p>Check the <a onClick={() => goToHistorical()} style={{ cursor: 'pointer', textDecoration: 'underline' }}>Results Page</a> or wait for completion.</p>
                                </div>
                            ),
                            duration: 10,
                        });

                        setLoading(false);
                        setIsMainUploadLoading(false);
                        return;
                    }

                    console.log("The response from main upload is:", response);
                    const jobID = response.data.jobID;
                    uploadingJobIDRef.current = jobID;
                    setSelectedHistoricalJD(jobID);
                    setIsMainUploadLoading(false);

                    if (window.EventSource) {
                        // EventSource mechanism is available - so do the connection
                        connectEventSource(false, jobID);
                    } else {
                        console.warn("Browser does not support EventSource");
                        connectEventSource(true, jobID);
                    }
                    setLoading(true);
                })
                .catch(error => {
                    message.error('Upload failed');
                    console.error(error);
                    setLoading(false);
                    setIsMainUploadLoading(false);
                });
        });
    };



    const dropdownOptions = [
        'Functional Skill Set',
        'Industry Experience',
        'Longevity',
        'Grammatical Skills',
        'Education',
        'Collaborative Skills',
        'Career Progression',
        'Default',
    ];

    const handleCreateManualJD = (values) => {
        console.log('=== handleCreateManualJD Debug ===');
        console.log('values:', values);
        console.log('jobDescription:', values.jobDescription);
        setManualEntryUsed(true);
        selectedOptions.manualUsed = "true";

        // Clear upload state when manual entry is used
        setJdFiles([]);
        setuploadUsed(false);

        setManualJDData([...manualJDData, values]);
        setJdText(values.jobDescription);
        setJdFilepath('');
        setManualEntryVisible(false);
        setIsUploadDisabled(true);
    };
    const handleClearManualEntry = () => {
        console.log('Clearing manual entry from parent');
        setManualEntryUsed(false);
        setManualJDData([]);
        setManualEntryVisible(false);
        setIsUploadDisabled(false);
        setSelectedOptions(prev => ({
            ...prev,
            manualUsed: "false"
        }));
    };
    const handleClearUpload = () => {
        console.log('Clearing upload from parent');
        setJdFiles([]);
        setuploadUsed(false);
        setIsUploadDisabled(false);
    };

    const manualJDColumns = [
        { title: 'Job Title', dataIndex: 'jobTitle', key: 'jobTitle', width: 200, align: 'center', onHeaderCell: () => ({ className: 'manual-table-header' }) },
        { title: 'Seniority', dataIndex: 'seniority', key: 'seniority', width:100, align: 'center', onHeaderCell: () => ({ className: 'manual-table-header' }) },
        { title: 'Job Description', dataIndex: 'jobDescription', key: 'jobDescription', width: 750, align: 'left', onHeaderCell: () => ({ className: 'manual-table-header' }) },
    ];

    const goToNextPage = () => {
        if (currentStep === 1 && (jdFiles.length === 0 && !manualEntryUsed && (selectedOptions.chosenJD === ""))) {
            message.error('Please add a JD before proceeding.');
        } else {
            setCurrentStep(currentStep + 1);
        }
    };

    const goToHistorical = () => {
        resetApplicationState()
        setCurrentStep(3);
    };

    const goToFirstStep = () => {
        setCurrentStep(1);
    };

    function isObjectEmpty(obj) {
        for (const key in obj) {
            if (key === 'firstPriority') {
                if (obj[key] === '') {
                    return true;
                }
            }
        }
        return false;
    }

    const handleCriteriaChange = useCallback((criteria) => (e) => {
        setAdditionalCriteria(prevCriteria => ({
            ...prevCriteria,
            [criteria]: e.target.value
        }));
    }, []);

    const SelectPriority = ({ dropdownOptions }) => {
        const handleSelectChange = (value, priority) => {
            setSelectedOptions(prev => ({ ...prev, [priority]: value }));
        };
        const width = 1045;
        const dropdownWidth = (width * 2) / 3;

        return (
            <div style={{ display: 'flex', justifyContent: 'space-between', width: width }}>
                <div style={{ width: `${dropdownWidth}px`, marginRight: '35px' }}>
                    <div>1st Priority</div>
                    <Select
                        value={selectedOptions.firstPriority}
                        onChange={value => handleSelectChange(value, 'firstPriority')}
                        style={{ width: '100%' }}
                        placeholder="Select"
                        disabled={selectedOptions.chosenJD !== "" || isBackButtonClicked}
                    >
                        {dropdownOptions.filter(option => option === 'Default' || !Object.values(selectedOptions).includes(option)).map(option => (
                            <Select.Option key={option} value={option}>{option}</Select.Option>
                        ))}
                    </Select>
                </div>
                <div style={{ width: `${dropdownWidth}px`, marginLeft: '35px', marginRight: '35px' }}>
                    <div>2nd Priority</div>
                    <Select
                        value={selectedOptions.secondPriority}
                        onChange={value => handleSelectChange(value, 'secondPriority')}
                        style={{ width: '100%' }}
                        placeholder="Select"
                        disabled={selectedOptions.chosenJD !== "" || isBackButtonClicked}
                    >
                        {dropdownOptions.filter(option => option === 'Default' || !Object.values(selectedOptions).includes(option)).map(option => (
                            <Select.Option key={option} value={option}>{option}</Select.Option>
                        ))}
                    </Select>
                </div>
                <div style={{ width: `${dropdownWidth}px`, marginLeft: '35px' }}>
                    <div>3rd Priority</div>
                    <Select
                        value={selectedOptions.thirdPriority}
                        onChange={value => handleSelectChange(value, 'thirdPriority')}
                        style={{ width: '100%' }}
                        placeholder="Select"
                        disabled={selectedOptions.chosenJD !== "" || isBackButtonClicked}
                    >
                        {dropdownOptions.filter(option => option === 'Default' || !Object.values(selectedOptions).includes(option)).map(option => (
                            <Select.Option key={option} value={option}>{option}</Select.Option>
                        ))}
                    </Select>
                </div>
            </div>
        );
    };
    const getLoadingMessage = (status) => {
        switch (status) {
            case 'initializing':
                return 'Please hang on while we set things up...';
            case 'processing':
                return "Our AI's deep in detective mode - sorting CVs, spotting gems, and stacking your shortlist.";
            case 'pending':
                return 'Getting ready to analyze your CVs...';
            default:
                return 'Processing...';
        }
    };

    const SelectExistingJD = async (open) => {
        const appendCookieToFormData = async () => {
            var userCookie = "default";
            if (!getCookie("userSession")) {
                //userCookie = await createCookie();
                console.log("Warning no cookie found:");
                onLogout();
            } else {
                userCookie = getCookie("userSession");
            }
            return userCookie;
        };

        const getJDListCall = async (userCookie, open) => {
            const formDataJDList = new FormData();
            formDataJDList.append('session-cookie', userCookie);
            if (open === "true") {
                console.log("Requesting only open jobs")
                formDataJDList.append('jd-type', "open");
            }
            return axios.post(backend_url + '/v1/jd-list', formDataJDList, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
                .then(response => {
                    console.log("JD List response:", response.data);
                    return response.data;
                })
                .catch(error => {
                    if (error.response && error.response.status === 400) {
                        return [];
                    } else {
                        return [];
                    }
                });
        };

        let userCookie = await appendCookieToFormData();
        let list = await getJDListCall(userCookie, open);
        list.sort((a, b) => {
            const aNumber = parseInt(a.JDName.split('.')[0]);
            const bNumber = parseInt(b.JDName.split('.')[0]);
            return aNumber - bNumber;
        });
        return list;
    };

    const ExistingJDDropdown = ({ setSelectedJD, selectedJD, getHistoricalData }) => {
        const handleSelectChange = (value) => {
            if (!getHistoricalData) {
                console.log("upload JD version of existing JD Dropdown")
                setSelectedJD(prev => ({ ...prev, ["chosenJD"]: value }));
            } else {  // This is for when used as the historical scores dropdown
                console.log("Historical scores version of JD Dropdown")
                setSelectedJD(value);
            }
            if (getHistoricalData) {
                getHistoricalData(value);
            }
        };

        const handleClick = () => {
            if (existingJDList.length === 0) {
                message.error('No previous JDs found', 5);
            }
        };

        return (
            <div style={{ width: `300px`, marginTop: '25px', marginBottom: '25px' }}>
                <div style={{ marginBottom: '5px' }}>
                    Previous Job Descriptions:
                </div>
                <Select
                    value={selectedJD}
                    onChange={value => handleSelectChange(value)}
                    onFocus={handleClick}
                    style={{ width: '100%' }}
                    placeholder=""
                    loading={jdListLoading}
                >
                    {existingJDList.map((jd, index) => (
                        <Select.Option key={index} value={jd.JDId || ''}>
                            {jd.JDName || ''}
                        </Select.Option>
                    ))}
                </Select>
            </div>
        );
    };

    const setInitialFlagColors = (data) => {
        const initialFlags = data.reduce((acc, curr) => {
            acc[curr.ApplicationID] = curr.FlagColour === 'blank' ? '' : curr.FlagColour;
            return acc;
        }, {});
        setFlags(initialFlags);
    };

    const getHistoricalData = (jdID) => {
        const currentSelectedCandidates = [...selectedCandidates];
        setSelectedCandidates([]);
        const historicalFormData = new FormData();

        historicalFormData.append('chosenJD', jdID);

        const appendCookieToFormData = async (historicalFormData) => {
            var userCookie = "default";
            if (!getCookie("userSession")) {
                //userCookie = await createCookie();
                console.log("Warning no cookie found:");
                onLogout();
            } else {
                userCookie = getCookie("userSession");
            }
            historicalFormData.append('Cookie-Value', userCookie);
            return historicalFormData;
        };

        appendCookieToFormData(historicalFormData).then(updatedFormData => {
            axios.post(backend_url + '/v1/previous-jd', updatedFormData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
                .then(response => {
                    console.log("Historical data response:", response.data)
                    setReturnedCriteria(response.data[1].CriteriaNames);
                    setJobName(response.data[2].jobName);
                    setJobID(response.data[2].jobID);
                    setJobData(response.data[2]);
                    if (response.data[2].jdText) {
                        console.log("Found JD text in response:", response.data[2].jdText.substring(0, 100) + "...");
                        setJdText(response.data[2].jdText);
                        setJdFilepath('');
                    } else {
                        console.log("No JD text found in response");
                        setJdText('');
                        setJdFilepath('uploaded');
                    }
                    const modifiedData = response.data[0].map(item => ({
                        ...item,
                        AcceptanceBody: encodeURIComponent(item.AcceptanceBody),
                        RejectionBody: encodeURIComponent(item.RejectionBody)
                    }));
                    setHistoricalData(modifiedData);
                    setInitialFlagColors(modifiedData);

                    setSelectedCandidates(currentSelectedCandidates.filter(selected =>
                        modifiedData.some(dataItem => dataItem.ApplicationID === selected.ApplicationID)
                    ));
                })
                .catch(error => {
                    message.error('Data retrieval failed');
                    console.error("Historical data retrieval failed: ", error);
                });
        });
    };

    const getProcessedResults = (jobID) => {
        // Retrieves the results for the just submitted CV evaluation job
        // Calls same API as getHistoricalData - probably could refactor to combine them
        const jobFormData = new FormData();
        jobFormData.append('chosenJD', jobID);

        const appendCookieToFormData = async (jobFormData) => {
            var userCookie = "default";
            if (!getCookie("userSession")) {
                //userCookie = await createCookie();
                console.log("Warning no cookie found:");
                onLogout();
            } else {
                userCookie = getCookie("userSession");
            }
            jobFormData.append('Cookie-Value', userCookie);
            return jobFormData;
        };

        appendCookieToFormData(jobFormData).then(jobCookieFormData => {
            axios.post(backend_url + '/v1/previous-jd', jobCookieFormData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
                .then(response => {
                    console.log("Processing data response:", response.data)
                    setReturnedCriteria(response.data[1].CriteriaNames);
                    const modifiedData = response.data[0].map(item => ({
                        ...item,
                        AcceptanceBody: encodeURIComponent(item.AcceptanceBody),
                        RejectionBody: encodeURIComponent(item.RejectionBody)
                    }));
                    setJobName(response.data[2].jobName);
                    setJobID(response.data[2].jobID);
                    setJobData(response.data[2]);
                    if (response.data[2].jdText) {
                        setJdText(response.data[2].jdText);
                        //setJdFilepath('');
                    } else {
                        setJdText('');
                        //setJdFilepath('uploaded');
                    }
                    setData(modifiedData);
                    setInitialFlagColors(modifiedData);
                    //setSelectedCandidates(prev => prev.filter(selected =>
                      //  modifiedData.some(dataItem => dataItem.ApplicationID === selected.ApplicationID)
                   // ));
                    // ShowResultsTable set in event source const which calls this
                })
                .catch(error => {
                    message.error('Failed to retrieve results');
                    console.error("Processed data retrieval failed: ", error);
                });
        });
    };

    /*
    const handleButtonClick = async (record) => {
      // Handles the button click for a CV viewing request for a particular candidate
      const applicationId = record.ApplicationID;
      const destinationURL = backend_url + '/v1/cv-retrieval?sessionID=' + getCookie("userSession") + "&applicationID=" + applicationId + "&jobName=" + encodeURIComponent(selectedHistoricalJD);
      axios.get(destinationURL, { responseType: 'blob' })
          .then(response => {
            const contentType = response.headers['content-type'];
            const file = new Blob([response.data], { type: contentType });
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;

            const contentDisposition = response.headers['content-disposition'];
            let filename = 'file';
            if (contentDisposition) {
              const filenameRegex = /filename[^;=\n]*=((['"]).*?['"]|[^;\n]*)/;
              let matches = filenameRegex.exec(contentDisposition);
              if (matches != null && matches[1]) {
                filename = decodeURIComponent(matches[1].replace(/['"]/g, ''));
              }
            }
            link.download = filename;
            link.click();
          })
          .catch(error => {
            console.error("Document retrieval failed: ", error);
          });
    };

     */
    const handleButtonClick = async (record) => {
        console.log("Handling CV preview for:", record.Name);
        const applicationId = record.ApplicationID;
        const destinationURL = backend_url + '/v1/cv-retrieval?sessionID=' + getCookie("userSession") + "&applicationID=" + applicationId + "&jobName=" + encodeURIComponent(selectedHistoricalJD);

        try {
            const response = await axios.get(destinationURL, { responseType: 'blob' });
            const contentType = response.headers['content-type'];
            const file = new Blob([response.data], { type: contentType });

            if (contentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || contentType === 'application/msword') {
                // Use Mammoth to convert the Word document to HTML
                const reader = new FileReader();
                reader.readAsArrayBuffer(file);
                reader.onloadend = async () => {
                    const arrayBuffer = reader.result;
                    try {
                        const result = await mammoth.convertToHtml({ arrayBuffer });
                        const htmlContent = result.value; // HTML representation of the Word file
                        setCVRecord({ ...record, cvContent: htmlContent, cvType: 'text/html' });
                        setShowCVModal(true);
                        console.log("PDF failed")
                    } catch (err) {
                        console.error("Failed to convert Word document: ", err);
                    }
                };
            } else if (contentType === 'application/pdf' || contentType === 'text/plain') {
                const fileURL = URL.createObjectURL(file);
                setCVRecord({ ...record, cvContent: fileURL, cvType: contentType });
                setShowCVModal(true);
            } else {
                console.error("Unsupported file type for preview.");
            }
        } catch (error) {
            console.error("Document retrieval failed: ", error);
        }
    };


    const handlePrescreenClick = (record) => {
        // Handles when the prescreen button is clicked for a particular candidate
        console.log("Handle Prescreen request for:", record.Name)
        setPrescreenRecord(record);
        setShowPrescreenModal(true);
    };

    const handleResultClick = (record) => {
        // Handles when the prescreen button is clicked for a particular candidate
        console.log("Handle Prescreen result request for:", record.Name)
        setPrescreenRecord(record);
        setShowPrescreenResultModal(true);
    };
    const handleSummaryClick = (record)=> {
        console.log("Handle the sunmmary and applicants fit to JD", record.Name)
        const summaryRecordWithPriority = {
            ...record,
            returnedCriteria: returnedCriteria.length > 0 ? returnedCriteria : undefined, // Add returnedCriteria if non-empty
            allCandidatesData: currentStep === 3 ? historicalData : data,
        };
        
        if (jobData) {
            summaryRecordWithPriority.priority1 = jobData.priority1;
            summaryRecordWithPriority.priority2 = jobData.priority2;
            summaryRecordWithPriority.priority3 = jobData.priority3;
        }
        
        setSummaryRecord(summaryRecordWithPriority);
        console.log("criteria2", record.criteria2)
        setShowSummaryModal(true);
    }

    if (loggedIn === false) {
        return <Navigate to="/login" />;
    }

    return (
        <div style={{ width: '100%', margin: '0px auto', maxWidth: '3000px', padding: '0 0px', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: 'transparent'}}>
            <NavigationBar
                loggedIn={loggedIn}
                onLogout={onLogout}
                goToHistorical={goToHistorical}
                goToFirstStep={resetApplicationState}
                goToSettings={navigateToSettings}
            />

            {/*
            <UpperBanner onLogout={onLogout} />
            <div style={{ width: '100%', paddingTop: '2px', top: '10px', zIndex: 999 }}>
                <BlueBanner onLogout={onLogout} displayLogout={loggedIn} loggedIn={loggedIn} goToHistorical={goToHistorical} goToFirstStep={resetApplicationState} />
            </div>
            */}
            <SwitchTransition mode="out-in">
                <CSSTransition key={currentStep} classNames="fade" timeout={400}>
                    <div>
                        <div>
                            <PreScreeningModal open={showPrescreenModal}
                                               closeModal={() => {
                                                   setShowPrescreenModal(false);
                                                   setSelectedCandidates([]);
                                               }}
                                               record={prescreenRecord} backendURL={backend_url} getCookie={getCookie}
                                               jobTitle={jobName} jobID={jobID}
                                               onPrescreenSubmitted={() => {
                                                   // Refresh status for submitted candidate(s)
                                                   if (prescreenRecord) {
                                                       if (Array.isArray(prescreenRecord)) {
                                                           prescreenRecord.forEach(candidate => {
                                                               if (candidate.ApplicationID) {
                                                                   checkPrescreenStatus(candidate.ApplicationID);
                                                               }
                                                           });
                                                       } else if (prescreenRecord.ApplicationID) {
                                                           checkPrescreenStatus(prescreenRecord.ApplicationID);
                                                       }
                                                   }
                                               }}/>
                        </div>
                        <div>
                            <ResultsModal open={showPrescreenResultModal} setOpen={setShowPrescreenResultModal}
                                          record={prescreenRecord} backendURL={backend_url} getCookie={getCookie}/>
                        </div>
                        <div>
                            <SummaryModal open={showSummaryModal} setOpen={setShowSummaryModal}
                                          record={summaryRecord}  backendURL={backend_url} getCookie={getCookie}/>
                        </div>
                        <div>
                            <PreviewCVModal open={showCVModal} setOpen={setShowCVModal} record={cvRecord} backendURL={backend_url} getCookie={getCookie} title="CV Preview" />
                        </div>
                        <div>
                            <PrescreeningStatusModal
                                open={showPrescreenStatusModal}
                                setOpen={setShowPrescreenStatusModal}
                                record={prescreenRecord}
                                backendURL={backend_url}
                                getCookie={getCookie}
                                onRetryPrescreen={handleRetryPrescreen}
                            />
                        </div>

                        {showResultsTable ? (
                            <ModernResultsStep
                                key={renderKey}
                                data={data}
                                returnedCriteria={returnedCriteria}
                                flags={flags}
                                cycleColor={cycleColor}
                                handleButtonClick={handleButtonClick}
                                handleUnifiedPrescreenClick={handleUnifiedPrescreenClick}
                                handleSummaryClick={handleSummaryClick}
                                prescreenLoading={prescreenLoading}
                                getPrescreenButtonColor={getPrescreenButtonColor}
                                isMultiSelect={isMultiSelect}
                                selectedCandidates={selectedCandidates}
                                setSelectedCandidates={setSelectedCandidates}
                                handleMultiplePrescreen={handleMultiplePrescreen}
                                ENABLE_MULTISELECT_FEATURE={ENABLE_MULTISELECT_FEATURE}
                                backendURL={backend_url}
                                jdFilepath={jdFilepath}
                                jdText={jdText}
                                jobID={jobID}
                            />
                        ) : currentStep === 1 ? (
                            <JobDescriptionStep
                                // Manual entry props
                                manualEntryVisible={manualEntryVisible}
                                setManualEntryVisible={setManualEntryVisible}
                                manualEntryUsed={manualEntryUsed}
                                uploadUsed={uploadUsed}
                                handleCreateManualJD={handleCreateManualJD}
                                manualJDData={manualJDData}
                                manualJDColumns={manualJDColumns}
                                handleClearManualEntry={handleClearManualEntry}
                                handleClearUpload={handleClearUpload}

                                // Upload props
                                handleJdFilesAdded={handleJdFilesAdded}
                                isUploadDisabled={isUploadDisabled}
                                handleListEmpty={handleListEmpty}

                                // Existing JD props
                                setSelectedOptions={setSelectedOptions}
                                selectedOptions={selectedOptions}
                                existingJDList={existingJDList}
                                jdListLoading={jdListLoading}

                                // Navigation props
                                goToNextPage={goToNextPage}

                                // Other props
                                backendURL={backend_url}
                                jdFilepath={jdFilepath}
                                jdText={jdText}
                                jobID={jobID}
                            />
                        ): currentStep === 2 ? (
                            <ModernAnalysisStep
                                dropdownOptions={dropdownOptions}
                                selectedOptions={selectedOptions}
                                setSelectedOptions={setSelectedOptions}
                                additionalCriteria={additionalCriteria}
                                handleCriteriaChange={handleCriteriaChange}
                                setAdditionalCriteria={setAdditionalCriteria} 
                                AdditionalContent={AdditionalContent}
                                setAdditionalContent={setAdditionalContent}
                                handleCvFilesAdded={handleCvFilesAdded}
                                handleDeleteCvFile={handleDeleteCvFile}
                                handleUpload={handleUpload}
                                isMainUploadLoading={isMainUploadLoading}
                                loading={loading}
                                progress={progress}
                                showCheck={showCheck}
                                isBackButtonClicked={isBackButtonClicked}
                                backendURL={backend_url} 
                            />
                        ) : (

                            <ModernHistoricalStep
                                key={renderKey}
                                // Dropdown props
                                existingJDList={existingJDList}
                                selectedHistoricalJD={selectedHistoricalJD}
                                setSelectedHistoricalJD={setSelectedHistoricalJD}
                                getHistoricalData={getHistoricalData}
                                jdListLoading={jdListLoading}

                                // Results data
                                historicalData={historicalData}
                                returnedCriteria={returnedCriteria}

                                // RankingTable props
                                flags={flags}
                                cycleColor={cycleColor}
                                handleButtonClick={handleButtonClick}
                                handleUnifiedPrescreenClick={handleUnifiedPrescreenClick}
                                handleSummaryClick={handleSummaryClick}
                                prescreenLoading={prescreenLoading}
                                getPrescreenButtonColor={getPrescreenButtonColor}
                                isMultiSelect={isMultiSelect}
                                selectedCandidates={selectedCandidates}
                                setSelectedCandidates={setSelectedCandidates}
                                handleMultiplePrescreen={handleMultiplePrescreen}
                                ENABLE_MULTISELECT_FEATURE={ENABLE_MULTISELECT_FEATURE}
                                backendURL={backend_url}
                                jdFilepath={jdFilepath}
                                jdText={jdText}
                                jobID={jobID}
                            />
                        )}
                    </div>
                </CSSTransition>
            </SwitchTransition>
        </div>
    );
};

export default RankingPage;
